module.exports = __webpack_public_path__ + "assets/script.35e15cd5.svg";